/**
 * 成功注册用户
 */
<template>
    <div class="suc-user-box">
      <div class="rank-box">
        <div v-if="userNumber" class="img-box">
          <img src="https://oss.aqdpay.com/appweb/shareApp/suc.png" alt="">
          <span>恭喜您注册成功！</span>
        </div>
        <div v-if="!userNumber" class="img-box">
          <img src="https://oss.aqdpay.com/appweb/shareApp/suc.png" alt="">
          <span>您已经注册过了，欢迎回归！</span>
        </div>
      </div>
      <div class="prize-box" @click="handleDownLoad">
        <img v-if="userNumber" src="https://oss.aqdpay.com/appweb/shareApp/prizeNew.png" alt="">
        <img v-if="!userNumber" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/shareApp/prizeNewRegisted.png" alt="">
        <!-- <div class="download-btn" @click="handleDownLoad">{{btnText}}</div> -->
      </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
      title: '您已注册成功',
      btnText: '下载便捷青岛APP',
      userNumber: '10000'
    }
  },
  created () {
    this.userNumber = this.$route.query.num
  },
  methods: {
    handleDownLoad () {
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang='scss' scoped>
.suc-user-box {
  box-sizing: border-box;
  min-height: 100vh;
  background: #1258C8 url('https://oss.aqdpay.com/appweb/shareApp/sharebg.png') no-repeat;
  background-size: 100%;
  padding-top: 15px;
}
.rank-box {
  margin: 15px;
  background: url('https://oss.aqdpay.com/appweb/shareApp/sucbg.png') no-repeat;
  background-size: cover;
  text-align: center;
  color: #0BA268;
  font-size: 14px;
}
.img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}
.prize-box {
  margin: 0 auto;
  position: absolute;
  bottom: 1%;
  padding: 12px;
  img {
    width: 100%;
  }
}
.download-btn {
  box-sizing: border-box;
  margin: 20px 0;
  padding: 10px 5px;
  background: #3782fb;
  font-size: 17px;
  color: #fff;
  text-align: center;
  border-radius: 20px;
}

</style>
